import React, { useState } from 'react';

import faqImg from '../assets/images/phone/anasayfa.jpg'


import { FiChevronUp } from 'react-icons/fi';

import { faq } from '../data/data';

interface FaqData {
    id:number;
    title:string;
    desc:string
}

export default function Faq() {
    let [ activeTab, setActiveTab ] = useState<number>(1)

  return (
    <div className="container relative">
      <div className="grid md:grid-cols-2 grid-cols-1 gap-8 items-center">
        {/* Sol Sütun: SSS */}
        <div className="w-full">
          <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Sıkça Sorulan Sorular</h6>
          <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Sorularınız mı var? Hemen göz atın!</h4>
          <p className="text-slate-400 max-w-xl mx-auto">Size yardımcı olacak pratik bilgiler ve kolay anlatımlarla, uygulamamızı daha rahat keşfedin. Amacınıza ulaşmanız için her adımda yanınızdayız!</p>
          <div id="accordion-collapseone" className="mt-8">
            {faq.map(( item:FaqData, index:number ) => {
              return(
                <div className={`relative shadow dark:shadow-gray-800 rounded-md overflow-hidden ${item.id !== 1 ?'mt-3' : ''}`} key={index}>
                  <h2 className="font-semibold">
                    <button type="button" onClick={() =>setActiveTab(item.id)} className={`flex justify-between items-center p-5 w-full font-medium text-start ${activeTab === item.id ? 'bg-slate-50/50 dark:bg-slate-800/20 text-red-500' : ''}`}>
                      <span>{item.title}</span>
                      <FiChevronUp className={`size-4 shrink-0 ${activeTab === item.id ? '' : 'rotate-180'}`}/>
                    </button>
                  </h2>
                  <div className={`${activeTab === item.id ? '' : 'hidden' }`}>
                    <div className="p-5">
                      <p className="text-slate-400 dark:text-gray-400">{item.desc}</p>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {/* Sağ Sütun: Görsel ve Sayaç */}
        <div className="flex flex-col items-center justify-center w-full">
          <div className="relative">
            <img src={faqImg} alt="Uygulama Ekranı" className="max-w-sm rounded-xl shadow-lg" />
          </div>
        </div>
      </div>
    </div>
  )
}
